export default __webpack_public_path__ + "static/media/foodz@2x.65f800c5.png";